import React from 'react'
import { FormattedMessage } from 'react-intl'

const languageCode = {
  l: (text) => (
    <a
      href={process.env.REACT_APP_LANGUAGE_CODE_URL}
      className="text-blue-primary"
      target="_blank"
      rel="noopener noreferrer"
    >
      {text}
    </a>
  ),
}

export const tableDesc = (enabledAutomatedCall, classes) => {
  const preferLang = enabledAutomatedCall
    ? [
        {
          header: 'preferred_language',
          desce: (
            <FormattedMessage
              id="subscriber.dialog.howToImport.CSV.content.preferLanguage"
              values={languageCode}
            />
          ),
        },
      ]
    : []

  return [
    {
      header: 'first_name',
      desce: (
        <FormattedMessage
          id="subscriber.dialog.howToImport.CSV.content.firstName"
          values={{
            b2: (text) => <b className={classes.colorOne}>{text}</b>,
          }}
        />
      ),
    },
    {
      header: 'last_name',
      desce: (
        <FormattedMessage
          id="subscriber.dialog.howToImport.CSV.content.lastName"
          values={{
            b2: (text) => <b className={classes.colorOne}>{text}</b>,
          }}
        />
      ),
    },
    {
      header: 'unique_id',
      desce: (
        <FormattedMessage
          id="subscriber.dialog.howToImport.CSV.content.uniqueId"
          values={{
            b: (text) => <b>{text}</b>,
            b2: (text) => <br />,
          }}
        />
      ),
    },
    {
      header: 'date_of_birth',
      desce: (
        <FormattedMessage
          id="subscriber.dialog.howToImport.CSV.content.dateOfBirth"
          values={{
            b: (text) => <b>{text}</b>,
          }}
        />
      ),
    },
    {
      header: 'email',
      desce: (
        <FormattedMessage id="subscriber.dialog.howToImport.CSV.content.email" />
      ),
    },
    {
      header: enabledAutomatedCall
        ? 'country_code / automated_call_country_code'
        : 'country_code',
      desce: (
        <FormattedMessage id="subscriber.dialog.howToImport.CSV.content.countryCode" />
      ),
    },
    {
      header: enabledAutomatedCall
        ? 'phone_number / automated_call_number'
        : 'phone_number',
      desce: (
        <FormattedMessage id="subscriber.dialog.howToImport.CSV.content.phoneNumber" />
      ),
    },
    ...preferLang,
  ]
}
